import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function Projects() {
  useEffect(() => {
    document.title = 'Environmental Equipment Project References | Grace Wang'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">TRACEABLE REFERENCE CATEGORIES</p>
        <h1>Relevant Project and Manufacturing Experience</h1>
      </section>

      <section className="page-content">
        <div className="project-categories">
          <div className="category-tag">Integrated Wastewater Equipment</div>
          <div className="category-tag">Stainless Steel Air Treatment Equipment</div>
          <div className="category-tag">Sludge Dewatering Equipment</div>
          <div className="category-tag">Solid Waste Process Equipment</div>
        </div>

        <h2>Start with Your Project Requirements</h2>
        <p>Share the scope before scheduling the technical step.</p>
        <p>For an initial written review, share the application, capacity or airflow, key contaminants, required equipment scope, preferred materials, available drawings, destination and target schedule.</p>
        <Link to="/contact" className="btn-primary">Send Requirements by Email ↗</Link>
      </section>
    </div>
  )
}
